import type { BoardBuilderGlobalContext } from '@library/types/boardBuilder';
import { createContext } from 'react';

export const BoardBuilderContext = createContext<BoardBuilderGlobalContext>({
  bulkLeagueIdGroups: [],
  durations: [],
  games: [],
  leagueInfo: {
    baseLeagueFilters: [],
    id: '',
    name: '',
    rank: 0,
    active: false,
    icon: '',
    imageUrl: ''
  },
  searchValue: '',
  selectedDate: '',
  selectedDuration: '',
  selectedGames: [],
  selectedPositions: [],
  selectedTeams: []
});
